module.exports = __webpack_public_path__ + "static/img/brilliant-laptop-2x.f38b67b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brilliant-laptop-2x.png
// module id = qmSN
// module chunks = 0